import { Root, Thumb } from '@radix-ui/react-switch';
import type { MergeExclusive } from 'type-fest';

import { classNames } from '../Utils/classNames';

type ToggleSwitchProps = MergeExclusive<
  { ['aria-label']: string },
  { ['aria-describedby']: string }
> & {
  checked: boolean;
  disabled?: boolean;
  onCheckedChange: (checked: boolean) => void;
};

export function ToggleSwitch({
  checked,
  disabled,
  onCheckedChange,
  ...props
}: ToggleSwitchProps) {
  return (
    <Root
      className={classNames(
        'group',
        'radix-state-checked:bg-primary-6',
        'radix-state-unchecked:bg-gray-6',
        'relative inline-flex h-[24px] w-[44px] flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out',
        'focus-visible:ring-purple-500 focus:outline-none focus-visible:ring focus-visible:ring-opacity-75',
        disabled && 'pointer-events-none opacity-50'
      )}
      checked={checked}
      disabled={disabled}
      onCheckedChange={onCheckedChange}
      {...props}
    >
      <Thumb
        className={classNames(
          'group-radix-state-checked:translate-x-5',
          'group-radix-state-unchecked:translate-x-0',
          'pointer-events-none inline-block h-[20px] w-[20px] transform rounded-full bg-gray-2 shadow-lg-down ring-0 transition duration-200 ease-in-out'
        )}
      />
    </Root>
  );
}
